import mixpanel from 'mixpanel-browser';
import { getCompatEnv } from '@fabric-app/compat/capabilities/environment';

const createMixpanelProvider = () => {
  let analytics = null;
  return {
    initialize: async () => {
      const { ANALYTICS, isFabricDev } = getCompatEnv();
      if (!ANALYTICS?.MIXPANEL_TOKEN) return;
      analytics = mixpanel.init(ANALYTICS.MIXPANEL_TOKEN, {
        api_host: "/mxp",
        ignore_dnt: true,
        debug: isFabricDev,
        track_pageview: ANALYTICS.TRACK_PAGEVIEW,
        persistence: ANALYTICS.DISABLE_PERSISTENCE ? void 0 : "localStorage",
        disable_cookie: ANALYTICS.DISABLE_PERSISTENCE,
        disable_persistence: ANALYTICS.DISABLE_PERSISTENCE,
        stop_utm_persistence: ANALYTICS.DISABLE_PERSISTENCE,
        opt_out_persistence_by_default: ANALYTICS.DISABLE_PERSISTENCE,
        // Batch requests don't care for the config and always persist, this is unwanted behavior, so disabling it for now.
        batch_requests: !ANALYTICS.DISABLE_PERSISTENCE
      }, "default-mix");
    },
    track: async (event, properties) => {
      if (!analytics) return;
      await analytics.track(event, properties);
    },
    identify: (user) => {
      if (!analytics) return;
      if (!user) {
        analytics.reset();
        return;
      }
      analytics.identify(user.id);
      analytics.people.set({
        $name: user.name ?? null,
        $email: user.email ?? null,
        $avatar: user.avatar_url ?? null,
        $groups: user.groups ?? null
      });
    }
  };
};

export { createMixpanelProvider };
//# sourceMappingURL=mixpanelProvider.js.map
